import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TestSessionForRegistrationDto } from 'src/app/core/dtos/dto';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { DateTimeHelper } from 'src/app/core/services/helpers/date-time.helper';

@Component({
  selector: 'app-proof-of-identity-selection-summary',
  templateUrl: './proof-of-identity-selection-summary.component.html',
  styleUrls: ['./proof-of-identity-selection-summary.component.scss']
})
export class ProofOfIdentitySelectionSummaryComponent implements OnInit, OnChanges {

  @Input() testSession: TestSessionForRegistrationDto;
  @Input() nextStep?: string;

  testDate: Date;
  testTypeCssClass: string;
  wordPressUrl: string;
  isStudyMaterials: boolean;
  localTimeZone: string;

  constructor(
    private configHelper: ConfigHelper,
    private dateTimeHelper: DateTimeHelper,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.wordPressUrl = this.configHelper.getWordPressUrl();
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (this.activatedRoute.snapshot.url.join('') === "study-materials") {
      this.isStudyMaterials = true;
    }
  }

  ngOnChanges() {
    if (this.testSession) {
      const testDateUtcToLocal = this.dateTimeHelper.convertUTCDateToLocalDate(new Date(this.testSession.testDateTimeUtc));
      this.testDate = this.testSession.isWebDelivery ? testDateUtcToLocal : this.testSession.testDateTimeTestCentre;
      this.testTypeCssClass = this.configHelper.getTestTypeCssClass(this.testSession?.testTypeId);
    }
  }

  redirectTestSelection() {
    if (this.testSession.isWebDelivery) {
      this.router.navigate(['/registration/sitting-selection-web-delivery']);
    } else {
      this.router.navigate(['/registration/sitting-selection']);
    }
  }

  redirectNextStep() {
    this.router.navigate([this.nextStep]);
  }

}
